import { redirect } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import { getRequest, setResponseHeader } from '@tanstack/react-start/server';

import { getServerMessage } from '~/i18n/server-message.server.ts';
import { signInWithEmail } from '~/modules/auth/service.server.ts';
import SignInFormSchema from '~/modules/auth/sign-in-form-schema.ts';
import { safeRedirect } from '~/utils/http.server.ts';

import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';
import { commitAuthSession } from './session.server.ts';

export interface AuthMutationResult {
	readonly formError?: string;
	readonly status: 'error';
}

export const signInWithEmailMutation = createServerFn({ method: 'POST' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.sign-in', 'auth.session.cookie-write'],
			relatesTo: 'auth.sign-in-email',
		}),
	])
	.inputValidator(SignInFormSchema)
	.handler(async ({ data }) => {
		const request = getRequest();
		const authSession = await signInWithEmail(data.email, data.password);

		if (!authSession) {
			return {
				formError: getServerMessage(request, 'serverError.invalidCredentials'),
				status: 'error',
			} satisfies AuthMutationResult;
		}

		setResponseHeader(
			'Set-Cookie',
			await commitAuthSession(request, {
				authSession,
				flashErrorMessage: null,
			}),
		);

		throw redirect({
			href: safeRedirect(data.redirectTo, '/dashboard'),
		});
	});
